// src from https://dark0946.tistory.com/420
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phone'
})
export class PhonePipe implements PipeTransform {

  static format(num: string, displayType: 'normal'|'secret' = 'normal'): string {
    num = num.replace(/[^0-9]/g, '');
    let formatNum = '';
    if (num.length < 4) {
      return num;
    } else if (num.length < 8) {
      // 지역번호 제외 집전화 : @@@ - @@@@
      formatNum = displayType === 'secret' ? num.replace(/(\d{3})(\d{4})/, '***-$2') : num.replace(/(\d{3})(\d{4})/, '$1-$2');
    } else if (num.length < 9) {
      // 단축 연락처. Ex)1544-...., 1588-.... : @@@@ - @@@@
      formatNum = displayType === 'secret' ? num.replace(/(\d{4})(\d{4})/, '****-$2') : num.replace(/(\d{4})(\d{4})/, '$1-$2');
    } else if (num.length < 11) {
      if (num.startsWith('02')) {
        if (num.length < 10) {
          // 서울 일반 전화번호 : 02 - @@@ - @@@@
          formatNum = displayType === 'secret' ? num.replace(/02(\d{3})(\d{4})/, '02-***-$2') : num.replace(/02(\d{3})(\d{4})/, '02-$1-$2');
        } else {
          // 서울 국번 : 02 - @@@@ - @@@@
          formatNum = displayType === 'secret' ? num.replace(/02(\d{4})(\d{4})/, '02-****-$2') : num.replace(/02(\d{4})(\d{4})/, '02-$1-$2');
        }
      } else {
        // 지역번호 포함된 집전화 / 01x 구번호 사용자 가운데 3자리. @@@ - @@@ - @@@@
        formatNum = displayType === 'secret' ? num.replace(/(\d{3})(\d{3})(\d{4})/, '$1-***-$3') : num.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
      }
    } else {
      // 핸드폰 번호, 인터넷 전화. : @@@ - @@@@ - @@@@
      formatNum = displayType === 'secret' ? num.replace(/(\d{3})(\d{4})(\d{4})/, '$1-***-$3') : num.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
    }
    return formatNum;
  }

  constructor() { }

  public transform(num: string, displayType: 'normal'|'secret' = 'normal' ): string {
    return PhonePipe.format(num, displayType);
  }
}

